import React from 'react';
import { Section } from './Section';
import { Check, X } from 'lucide-react';
const forWho = ['Personas que sienten que su bondad está siendo explotada en el trabajo o en su familia.', 'Espectadores de Filosofía Prohibida que quieren llevar la teoría a la práctica diaria.', 'Profesionales que necesitan navegar oficinas políticas sin perder su integridad.', 'Emprendedores que necesitan leer las intenciones ocultas de socios y competidores.'];
const notForWho = ['Personas que buscan herramientas para dañar o estafar a otros de forma gratuita.', 'Quienes prefieren vivir en la ignorancia cómoda del "todo el mundo es bueno".', 'Aquellos que no están dispuestos a mirar honestamente sus propias inseguridades.'];
export function TargetAudience() {
  return <Section className="max-w-6xl" data-id="element-213">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-0 border border-border bg-darker" data-id="element-214">
        <div className="p-8 md:p-12 lg:border-r border-border" data-id="element-215">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8 text-foreground" data-id="element-216">
            Para quién es esto
          </h3>
          <ul className="space-y-6" data-id="element-217">
            {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-218">
                <Check className="w-6 h-6 text-blood flex-shrink-0 mt-1" data-id="element-219" />
                <span className="text-foreground/80 font-sans font-light leading-relaxed" data-id="element-220">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="p-8 md:p-12 bg-background/50" data-id="element-221">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8 text-foreground/60" data-id="element-222">
            Para quién NO es esto
          </h3>
          <ul className="space-y-6" data-id="element-223">
            {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-224">
                <X className="w-6 h-6 text-foreground/40 flex-shrink-0 mt-1" data-id="element-225" />
                <span className="text-foreground/60 font-sans font-light leading-relaxed" data-id="element-226">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}